import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22.5 11.175a.525.525 0 1 1-1.05 0A7.875 7.875 0 0 0 13.575 3.3a.525.525 0 0 1 0-1.05 8.925 8.925 0 0 1 8.925 8.925Zm-3.99 10.6c-1.11.607-2.433.834-3.82.677-1.61-.184-3.273-.83-4.917-1.888a16.994 16.994 0 0 1-3.06-2.504c-1.647-1.582-2.934-3.427-3.707-5.34-.905-2.24-1.014-4.317-.239-6.063.472-1.065 1.253-1.939 2.569-2.946l.103-.089c.366-.319.565-.448.875-.545a1.755 1.755 0 0 1 1.21.068c.554.231 1.037.661 1.513 1.306.308.418.551.869.846 1.554l.033.076.034.079c.34.783.453 1.182.457 1.712.005.626-.223 1.159-.68 1.634l-.178.183c-.349.356-.476.496-.608.67a3.967 3.967 0 0 0-.772 2.276c-.024 1.021.398 2.107 1.086 2.83 1.226 1.169 3.208 1.478 4.623.724.287-.153.569-.376.868-.688.04-.042.08-.087.148-.164l.06-.069c.27-.307.425-.457.637-.608.54-.384 1.188-.478 1.914-.317.366.082.727.217 1.2.442.095.045.182.087.385.187.648.318 1.179.669 1.626 1.084.758.703 1.081 1.261 1.028 1.99-.032.464-.192.769-.604 1.245l-.04.047c-.33.451-.645.807-1.24 1.405-.426.43-.87.77-1.35 1.032Zm.315-10.075c.29 0 .525-.235.525-.525A5.775 5.775 0 0 0 13.575 5.4a.525.525 0 0 0 0 1.05 4.725 4.725 0 0 1 4.725 4.725c0 .29.235.525.525.525Z",
      clipRule: "evenodd"
    }
  )
);
var SvgPhoneCallingFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PhoneCallingFilled_default = SvgPhoneCallingFilled;

export { PhoneCallingFilled_default as default };
